export enum EGlobalClassnames {
  ConfirmPopup = 'x-confirm-popup',
  Modal = 'x-modal',
  TerminalMode = 'ft-terminal-mode'
}
